<script>
	import { Tabs, TabList, TabPanel, Tab } from "../components/tabs/tabs";
	import ActivitiesBox from '../components/ActivitiesBox.svelte';
	import ActivityTerms from "../components/ActivityTerms.svelte";
	import ActivitiesOutDoorBox from '../components/ActivitiesOutDoorBox.svelte';
	let activitiesdata = [
		{
			icon: "rock-climbing_sketch.jpg",
			name: "ROCK CLIMBING",
			agegroup: "8 Years and Above.",
			levelcompetence: "Moderate",
			description: "It Is An Activity Need To Climb Up, Down Or Across On Artificial Rock Walls."
		},
		{
			icon: "zorb-bw.jpg",
			name: "LAND ZORBING",
			agegroup: "14 Years and Above.",
			weightlimit: "Above 40 Kgs and Not More than 75kgs",
			levelcompetence: "Easy",
			description: "Is The Sports Of Recreation Of Rolling Downhill Need To Climb Inside 12 Foot Giant Sphere Made Of Transparent Plastic Rock & Roll Across The Downhill."
		},
		{
			icon: "Zip-linie.jpg",
			name: "ZIP LINE",
			agegroup: "8 Years and Above.",
			levelcompetence: "Moderate",
			description: "Consists of a pulley suspended on a cable, mounted on an incline. It is designed to enable a user propelled by gravity to travel from the top to the bottom of the inclined cable by holding on to the freely moving pulley."
		},
		{
			icon: "Bamboo-Burma.png",
			name: "BAMBOO BURMA",
			agegroup: "8 Years and Above.",
			levelcompetence: "Easy",
			description: "This is a bridge that consists of a thick Bamboo to walk on & two other ropes to hold on to, between two trees."
			
		},
		{
			icon: "Slack-line.jpg",
			name: "SLACK LINE",
			agegroup: "8 Years and Above.",
			levelcompetence: "Moderate",
			description: "A line that consists of a slack to balance & walk on as a base & two other ropes to hold on to."
		},
		{
			icon: "COMMANDO-NET-bw.png",
			name: "COMMANDO NET",
			agegroup: "5 Years and Above.",
			levelcompetence: "Easy",
			description: "A bridge that consists of a thin green rope net to walk on to which is tied between the branches of the tree."
		},
		{
			icon: "russian-ladder_sketch.jpg",
			name: "RUSSIAN LADDER",
			agegroup: "8 Years and Above.",
			levelcompetence: "Difficult",
			description: "Is a Rope activity need to climb a vertical ladder made up of a bamboo tied with a rope & a bell on the top of it."
		},
		{
			icon: "BURMA-LOOP-bw.png",
			name: "BURMA LOOP",
			agegroup: "8 Years and Above.",
			levelcompetence: "Moderate",
			description: "This is a bridge that consists of a thick Black rope loop to walk on & two other ropes to hold on to it between two trees."
		},
		{
			icon: "burma_bridge_sketch.jpg",
			name: "BURMA BRIDGE",
			agegroup: "8 Years and Above.",
			levelcompetence: "Easy",
			description: "This is a bridge that consists of a thin green rope to walk on & two other ropes to hold on to it between two trees."
		},
		{
			icon: "Sky-walk.png",
			name: "SKY WALK",
			agegroup: "8 Years and Above.",
			levelcompetence: "Moderate",
			description: "It is an elevated bridgelike walkway built to cross a large space of two trees on a bamboo piece."
			
		},
		{
			icon: "ROPE-WALK-bw.png",
			name: "ROPE WALK",
			agegroup: " 8 Years to 16 years.",
			levelcompetence: "Moderate",
			description: "It is a long straight narrow lane of rope tied between two trees to cross from one end to the other."
		},
		{
			icon: "Trampoline-01.jpg",
			name: "TRAMPOLINE",
			agegroup: "5 Years and Above.",
			levelcompetence: "Easy",
			description: "Trampoline is a device consisting of piece of taut, strong fabric stretched over a steel frame using many coiled springs need to bounce on it for recreational purpose."
		},
		{
			icon: "Aqua-Zorb.jpg",
			name: "WATER ROLLER",
			agegroup: "8 Years to 16 years.",
			levelcompetence: "Moderate",
			description: "Is the recreation of rolling in water need to climb inside the giant 6 foot sphere & rock & roll across the water."
		},
		{
			icon: "Water-kids-zorb-01.jpg",
			name: "AQUA ZORBING",
			weightlimit: "Above 25 Kgs and Not More than 50 kgs.",
			agegroup: "8 Years and Above.",
			levelcompetence: "Moderate",
			description: "Is the recreation of rolling in water need to balance and stand/walk in 6 foot sphere made of transparent plastic on water surface."
		},
		{
			icon: "Fish-spa-01.jpg",
			name: "FISH SPA",
			agegroup: " 8 Years and Above.",
			levelcompetence: "Moderate",
			description: "It's a Pond having a little fishes clean off the dead and dry skin of your feet and enhances relaxing experience."
		},
		{
			icon: "archery.png",
			name: "ARCHERY",
			agegroup: " 8 Years and Above.",
			levelcompetence: "Difficult",
			description: "Is the art, practice, or skill of propelling arrows with the use of a bow."
		},
		{
			icon: "shooting.png",
			name: "SHOOTING",
			agegroup: "8 Years and Above.",
			levelcompetence: "Difficult",
			description: "Is the Art/Skill of shooting as many Bottles/Mango as you can with Bullets/Pallets in the fixed number of attempts"
		},
		{
			icon: "Bungee-running-01.jpg",
			name: "BUNGEE RUNNING",
			agegroup: "8 Years and Above.",
			levelcompetence: "Moderate",
			description: "Each participant attaches a body harness before attempting to run as far as he/she can before the bungee cord catapults them back to the start. Race against each other to see who can place the Velcro marker furthest along the centre wall before losing their footing."
		},
		{
			icon: "Paint-ball-01.jpg",
			name: "PAINT BALL",
			activityname: "Activity Name: Paint Ball, [Ideal for 8Pax min] (Add on Game 300/350).",
			agegroup: "18 Years and Above.",
			levelcompetence: "Moderate",
			description: "Is a sports in which players compete, in teams to eliminate opponents by tagging them with capsules containing water soluble dye and gelatin shell outside (referred to as paintballs) propelled from a device called a paintball marker (commonly referred to as a paintball gun)"
		},
		{
			icon: "pyramid_walk.png",
			name: "PYRAMID WALK",
			activityname: "Activity Name: Paint Ball, [Ideal for 8Pax min] (Add on Game 300/350).",
			agegroup: "8 Years and Above.",
			levelcompetence: "Difficult",
			description: "Is a rope activity where a piece of bamboo is tied with rope in a triangle shape to walk upon from one end to other end of tree."
		},
		{
			icon: "monkey_crawling.png",
			name: "MONKEY CRAWLING",
			activityname: "Activity Name: Paint Ball, [Ideal for 8Pax min] (Add on Game 300/350).",
			agegroup: "8 Years and Above.",
			levelcompetence: "Difficult",
			description: "Is a rope activity need to crawl over the rope which is tied at either branches of the tree in order to reach the other end."
		},

		{
			icon: "quake_walk.png",
			name: "QUAKE WALK",
			activityname: "Activity Name: Paint Ball, [Ideal for 8Pax min] (Add on Game 300/350).",
			agegroup: "8 Years and Above.",
			levelcompetence: "Difficult",
			description: "Is a Rope activity need to walk on suspended wooden planks anchored between two branches of the tree."
		}

	]

	let  activitiesoutdoordata = [
		{
			icon: "cricket.png",
			name: "CRICKET",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		},
		{
			icon: "football.png",
			name: "FOOTBALL",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		},
		{
			icon: "volleyball.png",
			name: "VOLLEYBALL",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		},
		{
			icon: "badminton.png",
			name: "BADMINTON",
			costcoupon: "Included in all package",
			agegroup: "8 and above",
			gear: "Provided"
		},
		{
			icon: "basketball.png",
			name: "BASKETBALL",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		},
		{
			icon: "tug_of_war.png",
			name: "TUG OF WAR",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		},
		{
			icon: "lagori.png",
			name: "LAGORI",
			costcoupon: "Included in all package",
			agegroup: "14 and above",
			gear: "Provided"
		},
		{
			icon: "hopscotch_bw.jpg",
			name: "HOPSCOTCH",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		}
	]

	let  indoordata = [
		{
			icon: "table_tennis.png",
			name: "TABLE TENNIS",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		},
		{
			icon: "carrom_bw.png",
			name: "CARROM",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		},
		{
			icon: "board_games.png",
			name: "BOARD GAMES",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		},
		{
			icon: "dart.png",
			name: "DART",
			costcoupon: "Included in all package",
			agegroup: "8 and above",
			gear: "Provided"
		},
		{
			icon: "football_BW.png",
			name: "FOOSBALL",
			costcoupon: "Included in all package",
			agegroup: "12 and above",
			gear: "Provided"
		}
	]
</script>

<div class="image-background">
	<h1 class="header_text_wrapper text-left"><span>ACTIVITIES</span><span class="separator"></span></h1>
</div>
<div class="primary">
	<Tabs>
		<TabList>
			<Tab>
				Adventure Rides
			</Tab>
			<Tab>
				Outdoor Sports
			</Tab>
			<Tab>
				Indoor Games
			</Tab>
		</TabList>

		<TabPanel>
			<div class="container-fluid">
				{#each activitiesdata as item}
					<ActivitiesBox activityname={item.activityname} weightlimit={item.weightlimit} name={item.name} icon={item.icon} agegroup={item.agegroup} description={item.description} levelcompetence={item.levelcompetence} />
				{/each}
			</div>
		</TabPanel>
		<TabPanel>
			<div class="main-menu-box">
				<div class="container-fluid">
					{#each activitiesoutdoordata as item}
						<ActivitiesOutDoorBox name={item.name} icon={item.icon} agegroup={item.agegroup} costcoupon={item.costcoupon} gear={item.gear} />
					{/each}
				</div>
			</div>
		</TabPanel>

		<TabPanel>
			<div class="main-menu-box">
				<div class="container-fluid">
					{#each indoordata as item}
						<ActivitiesOutDoorBox name={item.name} icon={item.icon} agegroup={item.agegroup} costcoupon={item.costcoupon} gear={item.gear} />
					{/each}
				</div>
			</div>
		</TabPanel>
	</Tabs>
	<ActivityTerms />
</div>

<style>
    .image-background {
        background: url("../images/Restaurant1.jpg") no-repeat center;
    }

	.main-menu-box {
		padding: 35px 10px;
	}
</style>